export default __webpack_public_path__ + "static/media/SC40.0baea3cf.mp4";